
import { FormDatePicker } from "components/form/FormDatePicker/FormDatePicker";
import { FormField } from "components/form/FormField/FormField";
import { Checkbox as CustomCheckbox } from "components/ui/Checkbox";

import style from "../CervicalCheck.module.css";

export const RelevantClinicalDetails = ({ form, today }) => {
  return (
    <>
      <h2
        style={{
          fontSize: "20px",
          lineHeight: "32px",
          marginTop: "24px",
        }}
      >
        Relevant Clinical Details
      </h2>
      <div className={style.inputGroupGrid}>
        <FormField name="lmp">
          <label className={style.addLetterFormLabel}>LMP</label>
          <div className={style.addPregnancyDatePickerWrapper}>
            <FormDatePicker
                form={form}
                name="lmp"
                emptyValue={today}
              />
          </div>
        </FormField>
        <div
          className={style.inputGroupGrid}
          style={{ marginTop: "24px", gap: "12px" }}
        >
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("ocp-hormones-hrt")} />
              OCP/Hormones/HRT
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("pre-post-transplant")} />
              Pre/Post Transplant
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("post-coital-bleeding")} />
              Post-coital bleeding
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("iucd")} />
              IUCD
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("dialysis")} />
              Dialysis
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("post-menopausal-bleeding")} />
              Post-menopausal bleeding
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("post-menopausal")} />
              Post-menopausal
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("hiv-positive")} />
              HIV Positive
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("sub-total-hysterectomy")} />
              Sub-total Hysterectomy
            </label>
          </fieldset>
          <fieldset className={style.medsCheckboxGroup}>
            <label className={style.pregnancyFormCheckboxLabel}>
              <CustomCheckbox {...form.register("total-hysterectomy")} />
              Total Hysterectomy
            </label>
          </fieldset>
        </div>
      </div>
    </>
  );
};
